var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(3, 3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 5.333c-6.041 0-9.893 5.476-10.562 6.502a.323.323 0 0 0-.013.336c.582 1.043 3.943 6.496 10.575 6.496 6.633 0 9.993-5.454 10.575-6.496a.323.323 0 0 0-.013-.336c-.669-1.027-4.52-6.502-10.562-6.502Z",
  stroke: "#830051",
  strokeWidth: 1.33333
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 4,
  fill: "#830051"
}))));

export default SvgEye;